import { ChannelItemType } from '../sic-lib/enums/ChannelItemType';

export enum ToastStatus {
    error,
    info,
    success,
}

/* 
    IMPORTANT: the value of the enum is important; the lower the value the higher the priority.
    If a notification with a higher priority than one that is currently being displayed, the displayed
    notification will be dismissed and the higher priority notification will be displayed.
 */
export enum ToastType {
    messageReceived = 1,
    generic = 2,
    contactAlert = 3,
}

export interface ToastItem {
    toastId: string;
    status: ToastStatus;
    type: ToastType;
    text: string;
    autoHide: number | null;
}

export interface ToastMessageReceived extends ToastItem {
    contactId: number;
    contactName: string;
    channelType: ChannelItemType;
    type: ToastType.messageReceived;
}

export interface ToastContactAlert extends ToastItem {
    contactId: number;
    type: ToastType.contactAlert;
    title: string;
}
